import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";

export default function AnimatedClock({ color = "#4caf50", size = 60 }) {
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const timeInterval = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        return () => clearInterval(timeInterval);
    }, []);

    // Calculate clock hand rotations
    const hours = currentTime.getHours() % 12;
    const minutes = currentTime.getMinutes();
    const seconds = currentTime.getSeconds();

    const hourRotation = hours * 30 + minutes * 0.5; // 30 degrees per hour, 0.5 per minute
    const minuteRotation = minutes * 6 + seconds * 0.1; // 6 degrees per minute, 0.1 per second
    const secondRotation = seconds * 6; // 6 degrees per second

    return (
        <Box
            sx={{
                position: "relative",
                width: size,
                height: size,
                minWidth: size,
            }}
        >
            {/* Clock Face */}
            <Box
                sx={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "50%",
                    border: `3px solid ${color}`,
                    backgroundColor: "white",
                    position: "relative",
                    boxShadow: 2,
                }}
            >
                {/* Center dot */}
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor: color,
                        transform: "translate(-50%, -50%)",
                        zIndex: 4,
                    }}
                />

                {/* Hour hand */}
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        width: 3,
                        height: 18,
                        backgroundColor: color,
                        transformOrigin: "50% 100%",
                        transform: `translate(-50%, -100%) rotate(${hourRotation}deg)`,
                        borderRadius: "2px 2px 0 0",
                        zIndex: 2,
                        transition: "transform 0.3s ease",
                    }}
                />

                {/* Minute hand */}
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        width: 2,
                        height: 24,
                        backgroundColor: color,
                        transformOrigin: "50% 100%",
                        transform: `translate(-50%, -100%) rotate(${minuteRotation}deg)`,
                        borderRadius: "2px 2px 0 0",
                        zIndex: 1,
                        transition: "transform 0.3s ease",
                    }}
                />

                {/* Second hand */}
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        width: "0.5px",
                        height: 26,
                        backgroundColor: color,
                        transformOrigin: "50% 100%",
                        transform: `translate(-50%, -100%) rotate(${secondRotation}deg)`,
                        borderRadius: "0.5px 0.5px 0 0",
                        zIndex: 3,
                        transition: "transform 0.1s linear",
                    }}
                />
            </Box>
        </Box>
    );
}

